import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import { toast } from "sonner";
import { Share2, Save } from "lucide-react";

const FIELDS = [
  { key: "social_instagram", label: "Instagram" },
  { key: "social_telegram", label: "Telegram" },
  { key: "social_whatsapp", label: "WhatsApp" },
];

export const SocialLinksManager = () => {
  const [form, setForm] = useState({});
  const [saved, setSaved] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/settings`).then(r => {
      const vals = {};
      FIELDS.forEach(f => { vals[f.key] = r.data[f.key] || ""; });
      setForm(vals); setSaved(vals);
    }).catch(() => {});
  }, []);

  const dirty = JSON.stringify(form) !== JSON.stringify(saved);

  const save = async () => {
    setSaving(true);
    try {
      for (const f of FIELDS) {
        await axios.put(`${API}/settings/${f.key}`, { value: (form[f.key] || "").trim() });
      }
      setSaved({ ...form });
      toast.success("Social aggiornati");
    } catch { toast.error("Errore nel salvataggio"); }
    finally { setSaving(false); }
  };

  return (
    <div className="glass-card p-6 max-w-3xl mt-6" data-testid="setting-social-section">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 flex items-center justify-center" style={{ backgroundColor: "rgba(47,216,168,0.15)" }}>
          <Share2 size={20} style={{ color: "var(--mm-gold)" }} />
        </div>
        <div>
          <h2 className="text-lg font-bold" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "var(--mm-text-primary)" }}>Social (Footer)</h2>
          <p className="text-xs" style={{ color: "var(--mm-text-muted)" }}>I bottoni social appaiono nel footer solo se il link è compilato</p>
        </div>
      </div>
      <div className="space-y-3">
        {FIELDS.map(f => (
          <div key={f.key}>
            <label className="block text-xs font-semibold uppercase mb-1" style={{ color: "var(--mm-text-muted)", fontFamily: "'Space Grotesk', sans-serif" }}>{f.label}</label>
            <input type="text" value={form[f.key] || ""} onChange={e => setForm({ ...form, [f.key]: e.target.value })}
              className="admin-input w-full" placeholder={`Link profilo ${f.label} (https://...)`} data-testid={`${f.key}-input`} />
          </div>
        ))}
        <button onClick={save} disabled={saving || !dirty}
          className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-bold transition-all"
          style={{ backgroundColor: dirty ? "var(--mm-gold)" : "rgba(255,255,255,0.05)", color: dirty ? "#000" : "var(--mm-text-muted)", fontFamily: "'Space Grotesk', sans-serif", opacity: dirty ? 1 : 0.5 }}
          data-testid="social-save-btn">
          <Save size={16} /> {saving ? "SALVATAGGIO..." : "SALVA"}
        </button>
      </div>
    </div>
  );
};
